export default (params) => ({
  trigger: {
    name: 'content_blocks.image_entrances.show',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'two_entrances',
          'four_entrances',
          'two_entrances_personalized',
          'four_entrances_personalized',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_content_block',
    },
    nonInt: true,
  },
});
